import { render, staticRenderFns } from "./categoryTable.vue?vue&type=template&id=5a75c348"
import script from "./categoryTable.vue?vue&type=script&lang=js"
export * from "./categoryTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports